import { useEffect, useRef } from 'react';
import { useStore } from '@services/store';
import { PlayerHeader } from '@components/PlayerHeader';
import { PlayerStatus } from '@components/PlayerStatus';
import { PlayerInfo } from '@components/PlayerInfo';
import { PlayerCurrency } from '@components/PlayerCurrency';
import { PlayerActions } from '@components/PlayerActions';

export const Dashboard = () => {
  const { currentPlayer, loadingPlayer } = useStore();
  const containerRef = useRef<HTMLDivElement>(null);

  // Ajuster la hauteur du widget Crisp quand le contenu change
  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current && (window as any).$crisp?.setHeight) {
        const height = containerRef.current.scrollHeight;
        // Crisp limite à 300px par défaut, on peut aller jusqu'à ~600px
        const crispHeight = Math.min(height, 600);
        console.log('Setting Crisp widget height to:', crispHeight, '(content height:', height, ')');
        (window as any).$crisp.setHeight(crispHeight);
      }
    };

    // Attendre que le DOM soit complètement rendu
    const timer = setTimeout(updateHeight, 100);

    return () => clearTimeout(timer);
  }, [currentPlayer, loadingPlayer]);

  if (loadingPlayer) {
    return (
      <div ref={containerRef} className="flex items-center justify-center py-8">
        <div className="text-crisp-gray text-sm">Chargement...</div>
      </div>
    );
  }

  if (!currentPlayer) {
    return (
      <div ref={containerRef} className="flex items-center justify-center py-8 px-4">
        <div className="text-center">
          <div className="text-crisp-gray text-sm">
            Aucune donnée de joueur disponible
          </div>
        </div>
      </div>
    );
  }

  return (
    <div ref={containerRef} className="w-full">
      <PlayerHeader player={currentPlayer} />
      <PlayerStatus player={currentPlayer} />
      <PlayerInfo player={currentPlayer} />
      <PlayerCurrency player={currentPlayer} />
      <PlayerActions />
    </div>
  );
};
